import * as React from "react";
import { ContentProps } from "components/flexComponents/Content/typings";
import { UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";
import { ViewExtraLarge, ViewLarge, ViewMedium, Viewport, ViewSmall } from "bernie-view";

export const HeroImageEditorial = (props: ContentProps) => {
  const flexComponent = props.flexComponent;
  const model = flexComponent && flexComponent.model;
  const items = (model && model.items && model.items.filter((item) => item)) || [];

  if (!model || items.length !== 2) {
    return null;
  }

  const [heroImageMediumLargeExtraLarge, heroImageSmall] = items.map((item) => item.media);

  const heroImageURLMediumLargeExtraLarge =
    heroImageMediumLargeExtraLarge && heroImageMediumLargeExtraLarge[0].mediaUrl;
  const heroImageURLSmall = heroImageSmall && heroImageSmall[0].mediaUrl;

  return (
    <Viewport>
      <ViewExtraLarge>
        <UitkFigure src={heroImageURLMediumLargeExtraLarge} ratio={UitkFigureAspectRatioType.R21_9} />
      </ViewExtraLarge>

      <ViewLarge>
        <UitkFigure src={heroImageURLMediumLargeExtraLarge} ratio={UitkFigureAspectRatioType.R21_9} />
      </ViewLarge>

      <ViewMedium>
        <UitkFigure src={heroImageURLMediumLargeExtraLarge} ratio={UitkFigureAspectRatioType.R21_9} />
      </ViewMedium>

      <ViewSmall>
        <UitkFigure src={heroImageURLSmall} ratio={UitkFigureAspectRatioType.R4_3} />
      </ViewSmall>
    </Viewport>
  );
};

export default HeroImageEditorial;
